export enum HeaderView {
    SingleManagerHeader,
    MultiManagerHeader,
    EmployeeHeader
}